// Days past today the Completion Date picker may reach while the Bumpout
// Timesheet workflow is active, indexed by `Date#getDay()` (Sunday first):
// Mon–Thu → tomorrow; Fri, Sat, Sun → the following Monday.
const DAYS_AHEAD_BY_WEEKDAY = [1, 1, 1, 1, 1, 3, 2];

/**
 * Latest selectable Completion Date for the Log Bump modal, as a local
 * calendar day. Holidays are not considered.
 */
export const getMaxCompletionDate = (
  today: Date,
  bumpoutTimesheetActive: boolean,
): Date => {
  const daysAhead = bumpoutTimesheetActive
    ? DAYS_AHEAD_BY_WEEKDAY[today.getDay()]
    : 0;

  return new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + daysAhead,
  );
};

export default getMaxCompletionDate;
